import { Autocomplete, Container, Grid2, Typography, Box, Button, Divider, Grid, Stack, Chip, Grow, IconButton, Modal, TextField, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, useMediaQuery } from "@mui/material";
import { LineChart } from '@mui/x-charts/LineChart';
import styles from "./Dashboard.module.css"
import styles1 from "./Card.module.css"

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import ApiClient from "../utilities/apiClient"
import AppConfig from "../utilities/appConfig"


import wvFour from "../assets/svg/wvFour.png"
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import errorIcon from "../assets/svg/error.svg"
import successIcon from "../assets/svg/success.svg"
import logo from "../assets/svg/cardlogo.svg"

import * as CryptoJS from 'crypto-js';
import { useNavigate } from "react-router-dom";
import { ResponsiveChartContainer } from "@mui/x-charts";
import { EnergySavingsLeaf } from "@mui/icons-material";
import React from "react";

export default function Dashboard({
    accounts, 
    investAmount, 
    setAmount,
    setPaymentStatusModel, 
    paymentAmount, 
    paymentTxId, 
    paymentSuccess,
    paymentOrderId,
    setPaymentFailure,
    setPaymentSuccess,
    paymentErrorMessage,
    setModal,
    setAmount1,
    setInvestmentType,
    setPaymentMode,
    paymentMode,
    selectedBank,
    setSelectedBank,setUserBanks,
    paymentFailure,
    card,
    setCard,
    modal,
    investmentType ,
    amount,
    setConfirmPayment,
    confirmPayment,
    userBanks,
    handlePayment,
    user,
    handleBankChange,
    handlePaymentModeChange,
    loader
}) {

  console.log("investmentAmt",investAmount,user)

    const screen650px = useMediaQuery("(max-height : 660px)")
    const screen600px = useMediaQuery("(max-width : 660px)")
    const screen700px = useMediaQuery("(max-height : 700px)")
    const screen1200px = useMediaQuery("(max-width : 1200px)")
    const screen1000px = useMediaQuery("(max-width : 1000px)")

    const navigate = useNavigate() 

    const traditional = {
        "title" : "Vision 2027",
        "Asset Class" : "Equity",
        "Benchmark" : "Nifty",
        "Launch Date" : "26 March 2025",
        "Rationale" : "Welcome to our Portfolio Vision 2027, a carefully curated investment strategy designed to strike the ideal balance between growth and stability. This portfolio is tailored for investors seeking a moderate risk approach, combining the potential for LargeCap &Midcap stocks. The constituent stocks included here have been carefully selected, as they are undergoing significant developments these days and expected to translate in their financials by 2027.",
        "key features" : [
            "Growth-Oriented Selection: Stocks have been chosen based on their potential to undergo significant developments that are expected to reflect in their financials by 2027.",
            "Future-Driven Approach: The portfolio focuses on sectors and businesses poised for strong performance over the next few years.",
            "Diversification: Investments are spread across multiple sectors and market capitalizations to reduce risk and enhance returns. This diversification ensures that the portfolio is not overly reliant on any single investment or market segment.",
            "Risk-Return Optimization: The combination of large-cap stability and mid-cap growth potential provides a balanced risk-reward ratio.",
            "Active Rebalancing: The portfolio is actively monitored and rebalanced, not out of compulsion but based on market opportunities and changes in the fundamentals. This ensures that the portfolio stays aligned with the investor's risk profile and financial objectives.",
            "Time Frame: Preferred time frame of holding the portfolio is 2-3 years, although the constituent stocks may be altered based on opportunities, valuation, outlook, valuation targets, or changes in fundamentals."
          ],
      disclaimer: "Investment in the securities market is subject to market risks. Read all the related documents carefully before investing. This report is not a guarantee of the performance of the stock price. Registration granted by SEBI, membership of BASL and certification from NISM in no way a guarantee of the performance of the intermediary or provide any assurance of returns to investors. Amiteshwar Singh (SEBI Reg. No.  INH100010013) did not receive any compensation or other benefits from the subject Company or third party in connection with the preparation of this research report. This document is not to be reported or copied or circulated or made available to others without prior permission. The information contained in this report has been obtained from sources that are considered to be reliable. However, Amiteshwar Singh has not independently verified the accuracy or completeness of the same. Amiteshwar Singh does not accept any responsibility of whatsoever nature for the information, statements and opinion given, made available or expressed herein or for any omission therein. Recipients of this report should be aware that past performance is not necessarily a guide to future performance and the value of investments can go down as well. The suitability or otherwise of any investments will depend upon the recipient's particular circumstances."
    }

    const energetic = {
        "title" : "VG Alpha High Risk High Return Portfolio",
        "Asset Class" : "Equity",
        "Benchmark" : "Nifty MidSmallcap 400",
        "Launch Date" : "01 April 2025",
        "Rationale" : "Welcome to our High Risk Portfolio, a carefully curated investment strategy designed to strike the ideal balance between growth and stability. This portfolio is tailored for investors seeking a moderate risk approach, combining the potential for Midcap, SmallCap & Micro Cap stocks. Considering the risk part we are somewhat flexible in terms of allocation. \n Typically this Portfolio constitutes max 4-7 stocks keeping total value of the Portfolio same.",
        "key features" : [
            "Not a Prototype Portfolio : This portfolio is not a stereotype one, meaning it is not constructed in a single day. It initially starts with 4-5 stocks and typically reaches its maximum number based on opportunities.",
            "Benefit of Joining: Investors get many live entry opportunities by participating in this type of portfolio.",
            "Optimal Asset Allocation: The portfolio maintains a balanced mix of small-cap and mid-cap stocks, typically in equal ratio depending on market conditions. This allocation helps mitigate volatility while capturing growth opportunities.",
            "Diversification: Investments are spread across multiple sectors and market capitalizations to reduce risk and enhance returns. This diversification ensures that the portfolio is not overly reliant on any single investment or market segment.",
            "Active Rebalancing & Time Frame: The portfolio is actively monitored and rebalanced based on market opportunities and changes in fundamentals. The preferred holding time frame is 4-5 years, although constituent stocks may be altered based on opportunities, valuations, outlook, or meeting price/valuation targets."
          ],
          disclaimer : "Investment in the securities market is subject to market risks. Read all the related documents carefully before investing. This report is not a guarantee of the performance of the stock price. Registration granted by SEBI, membership of BASL and certification from NISM in no way a guarantee of the performance of the intermediary or provide any assurance of returns to investors. VG Stock Research (SEBI Reg. No. INH100007985) did not receive any compensation or other benefits from the subject Company or third party in connection with the preparation of this research report. This document is not to be reported or copied or circulated or made available to others without prior permission. The information contained in this report has been obtained from sources that are considered to be reliable. However, VG Stock Research has not independently verified the accuracy or completeness of the same. VG Stock Research does not accept any responsibility of whatsoever nature for the information, statements and opinion given, made available or expressed herein or for any omission therein. Recipients of this report should be aware that past performance is not necessarily a guide to future performance and the value of investments can go down as well. The suitability or otherwise of any investments will depend upon the recipient's particular circumstances."
    }

    const [showDetails,setShowDetails] = useState(false)
    const [details,setDetails] = useState({})


    

    // useEffect(() => {
    //     setPaymentStatusModel(localStorage.getItem("cryptoSecret"))
    // }, [])

    useEffect(()=>{
        
    },[])

    const handleClose = (event) => {
        setPaymentFailure(false)
    }

    const handleBuy = (ele) =>{
        setModal(true)
        setInvestmentType(ele)
    }


    const uData = [0, 50, 100, 200, 300];
    const pData = [0, 40, 90, 150, 200];
    const xLabels = [
        'April 2020',
        'April 2021',
        'April 2022',
        'April 2023',
        'April 2024',
    ];

    const uData1 = [0, 50, 100, 200, 300];
    const pData1 = [0, 40, 90, 150, 200];
    const xLabels1 = [
        'April 2020',
        'April 2021',
        'April 2022',
        'April 2023',
        'April 2024',
    ];

    const [year, setYear] = useState(2)
    const [year1, setYear1] = useState(2)

    // useEffect(() => {
    //     const apiClient = new ApiClient(localStorage.getItem("token"))

    //     apiClient.fetchData(AppConfig.api.Subscription.bankList, "POST",
    //         {
    //             "mobileno" : localStorage.getItem("mobile"),
    //             "client_id": user?.client_id,
    //         })
    //         .then((response) => {
    //             if (response) {
    //                 let responseData = response
    //                 if (Array.isArray(responseData) && responseData.length > 0) {
    //                     console.info(`setUserBanks ${responseData}`);
    //                     setUserBanks(responseData);
    //                     if (responseData.length == 1) {
    //                         setSelectedBank(responseData[0])
    //                     }
    //                     else if (responseData.find(ele => ele.Default_Ac == "Yes")) {
    //                         const defaultBank = responseData?.length > 0 && responseData.find(ele => ele.Default_Ac == "Yes")
    //                         setSelectedBank(defaultBank)
    //                     } else {
    //                         setSelectedBank(responseData[0])
    //                     }
    //                 }
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }, [])

  console.log(paymentFailure,user, "paymentFailure")

    return (
        Object.entries(user).length !==0 &&
        <Grid2 className={styles.main}>
          {!card && <Typography className={styles.userName}>Welcome {user.name ? user.name : JSON.parse(localStorage.getItem("accounts"))[0]?.name}</Typography>}

            <>
                <Typography className={styles.congratulationText}>Congratulations for your wealth building journey with BullForce</Typography>

                <Grow in={true}>
                    <Grid2 className={styles.grid}>
                        <Grid2>
                            <Grid2 className={styles.subGrid} sx={{ display: "flex", flexDirection: "column", width: "100%" }} >
                                <Grid2 sx={{ display: "flex", width: "100%" }}>
                      <img src={logo} alt="wvlogo" className={styles.cardLogo} />
                                
                                    <Grid2 sx={{ display: "flex", width: "100%" }}>
                                        <Grid2 className={styles.invTypeTextGrid} >
                                            <Grid2>
                                                <Typography className={styles.energetic}> Traditional </Typography>
                                                <Typography className={styles.highrisk} > Moderate Risk - Long Term </Typography>
                                            </Grid2>
                                            <Button disabled = {loader} sx={{backgroundColor : loader && "#999999 !important"}} className={styles.investButton} onClick={()=>{
                                                setAmount(investAmount?.traditional)
                                                setAmount1(investAmount?.traditional)
                                                handleBuy({type : "Traditional" , risk : "Moderate Risk - Long Term"})
                                                }}>Invest</Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>


                                <Grid2 display="flex" sx={{ justifyContent: "space-between", alignContent: "center",alignItems : "end", margin: "3% 0 0 0","@media (max-height: 600px)": {
                                  marginTop: "1.5% !important",
                                } }}>
                                    <Grid2 className = {styles.amountGrid}>
                                        <Typography className={styles.fourty}> ₹{investAmount?.traditional} 
                                            
                                            </Typography>
                                        <Typography className={styles.mininvest}> Min. Investment </Typography>
                                    </Grid2>

                                    <Grid2>
                                    <Chip label="Equity" size="large" sx={{backgroundColor : "#34C759", color : "white", width : "75px", letterSpacing : "1px"}} />
                                        
                                    </Grid2> 

                                </Grid2>
                                                

                            </Grid2>
                  <Grid2 className={styles.chart}>


                    <Typography textAlign="center" sx={{
                      fontSize: "20px", fontFamily: "Inter600", pt: "20px", "@media (max-height: 630px)": {
                        pt: "10px",
                        fontSize: "18px"
                      }
                    }}>Vision 2027</Typography>

                    <Grid2 container justifyContent="space-between" pt={2}>
                      <Grid2 xs={6}>
                        <Typography sx={{ color: "grey" }} className={styles.raName} >
                          RA Name : <span style={{ color: "black" }}>Amiteshwar Singh</span>
                        </Typography>
                      </Grid2>

                      <Grid2 xs={6}>
                        <Typography sx={{ color: "grey" }} textAlign="right" className={styles.raName}>
                          SEBI Reg No: <span style={{ color: "black" }}> INH100010013</span>
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2 container justifyContent="space-between" >
                      <Grid2 xs={6}>
                        <Typography sx={{ color: "grey", fontSize: "15px" }} >
                          Skills : <span style={{ color: "black" }}>Fundamental analyst</span>
                        </Typography>
                      </Grid2>

                      <Grid2 xs={6}>
                        <Typography sx={{ color: "grey", fontSize: "15px" }} textAlign="right">
                          Experience : <span style={{ color: "black" }}>8 Years</span>
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Divider sx={{ marginTop: "10px" }} />
                    <Box display="flex" flexDirection="row" gap={1} mt="10px">
                      <Typography color="text.secondary" className={styles.investment_objective}>
                        Investment Objective/ Description : &nbsp;
                        <span variant="body2" style={{ color: "black" }}>
                          Emerging opportunities which may be translated into favourable outcome by 2027
                        </span>
                      </Typography>
                    </Box>
                    <Grid2 className={styles1.aboutGrid}>

                      {/* Holdings Distribution Section */}
                      <Typography className={styles1.about} sx={{
                        fontSize: '16px !important', mt: '20px', "@media (max-height: 700px)": {
                          marginTop: "8px"
                        }
                      }}>
                        Holdings Distribution
                      </Typography>
                      <Grid2 className={styles.lineGraph}>
                        {[{ title: '71.42%', color: '#30B0C7' }, { title: '28.58%', color: '#934FB5' }, { title: '0%', color: '#F4A261' }].map((ele, index) => {
                          return (
                            <Chip key={index} sx={{ background: ele.color, width: ele.title, height: '7px', borderRadius: '4px' }} />
                          );
                        })}
                      </Grid2>
                      <Grid2 className={styles1.sectorGrid} columnGap={2}>
                        {[{ title: 'Large Cap', color: '#30B0C7', percentage: "71.42%" }, { title: 'Mid Cap', color: '#934FB5', percentage: "28.58%" }].map((ele, index) => {
                          return (
                            <Box key={index}>
                              <Grid2 display="flex" justifyContent="center" alignItems="center">
                                <Grid2 sx={{ height: '10px', width: '10px', background: ele.color, borderRadius: '50%' }} />
                                <Typography className={styles1.capText}>{ele?.title} - <span style={{ fontWeight: "bold" }}>{ele?.percentage}</span></Typography>
                              </Grid2>

                            </Box>
                          );
                        })}
                      </Grid2>
                    </Grid2>
                    <Grid2 sx={{
                      display: "flex", justifyContent: "center", alignContent: "center", mt: "10px", "@media (max-height: 630px)": {
                        mt: "5px"
                      }
                    }}>
                      <Button sx={{
                        "@media (max-height: 630px)": {
                          pt: 0
                        }
                      }} onClick={() => {
                        setShowDetails(true)
                        setDetails(traditional)
                      }} disabled={loader} className={styles.knowMoreButton} >Know More <ArrowForwardIosIcon sx={{ fontSize: "14px" }} /> </Button>
                    </Grid2>

                  </Grid2>
                            
                        </Grid2>

                        <Grid2>
                            <Grid2 className={styles.subGrid1} sx={{ display: "flex", flexDirection: "column", width: "100%" }} >
                                <Grid2 sx={{ display: "flex", width: "100%" }}>
                      <img src={logo} alt="wvlogo"  className={styles.cardLogo} />

                                    <Grid2 sx={{ display: "flex", width: "100%" }}>
                                        <Grid2 className={styles.invTypeTextGrid} >
                                            <Grid2>
                                                <Typography className={styles.energetic}> Energetic </Typography>
                                                <Typography className={styles.highrisk} > High risk - Long Term </Typography>
                                            </Grid2>
                                            <Button disabled = {loader} sx={{backgroundColor : loader && "#999999 !important"}} className={styles.investButton} onClick={()=>{
                                                setAmount(investAmount?.energetic)
                                                setAmount1(investAmount?.energetic)
                                                handleBuy({type : "Energetic" , risk : "(High risk - Long Term)"})
                                                }} > Invest </Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>


                                <Grid2 display="flex" sx={{ justifyContent: "space-between", alignContent: "center",alignItems : "end", margin: "3% 0 0 0","@media (max-height: 600px)": {
                                  marginTop: "1.5% !important",
                                } }}>
                                    <Grid2 className = {styles.amountGrid}>
                                        <Typography className={styles.fourty}> ₹{investAmount?.energetic} 
                                            </Typography>
                                        <Typography className={styles.mininvest}> Min. Investment </Typography>
                                    </Grid2>

                                    <Grid2>
            
                                        <Chip label="Equity" size="large" sx={{backgroundColor : "#34C759", color : "white", width : "75px", letterSpacing : "1px"}} />
                                    </Grid2> 

                                </Grid2>


                            </Grid2>
                            <Grid2 className = {styles.chart}>
                            
            
                                <Typography textAlign="center" sx={{fontSize : "20px",fontFamily: "Inter600",pt : "20px","@media (max-height: 630px)": {
  pt : "10px",
  fontSize : "18px"
}}}>VG Alpha High Risk High Return Portfolio</Typography>
                                <Grid2 container justifyContent="space-between" pt={2}>
      <Grid2 xs={6}>
        <Typography sx={{color : "grey"}} className={styles.raName} >
        RA Name : <span style={{color : "black"}}>Vishal Gupta</span>
        </Typography>
      </Grid2> 

      <Grid2 xs={6}>
        <Typography sx={{color : "grey"}} textAlign="right" className={styles.raName}>
          SEBI Reg No: <span style={{color : "black"}}> INH100007985</span>
        </Typography>
      </Grid2>
    </Grid2>
    <Grid2 container justifyContent="space-between">
      <Grid2 xs={6}>
        <Typography sx={{color : "grey" , fontSize : "15px"}} className={styles.skills} >
        Skills : <span style={{color : "black"}}>Techno Funda Picks</span>
        </Typography>
      </Grid2> 

      <Grid2 xs={6}>
        <Typography sx={{color : "grey" , fontSize : "15px"}} textAlign="right" className={styles.skills}>
        Experience : <span style={{color : "black"}}>13+ Years</span>
        </Typography>
      </Grid2>
    </Grid2>
    <Divider sx={{marginTop : "10px"}}/>
                                <Box display="flex" flexDirection="row" gap={1} mt="10px">
      <Typography color="text.secondary" className={styles.investment_objective}>
        Investment Objective/ Description : <span variant="body2" style={{color : "black"}}> 
        High Risk High Return
      </span>
      </Typography>
    </Box>
    <Grid2 className={styles1.aboutGrid}>

  {/* Holdings Distribution Section */}
  <Typography className={styles1.about} sx={{ fontSize: '16px !important', mt: '50px',"@media (max-height: 700px)": {
  marginTop: "35px","@media (max-height: 630px)": {
    marginTop: "25px",
  }
} }}>
    Holdings Distribution
  </Typography>
  <Grid2 className= {styles.lineGraph}>
    {[{ title: '50%', color: ' #934FB5'}, { title: '50%', color: '#496E95' }].map((ele, index) => {
      return (
        <Chip key={index} sx={{ background: ele.color, width: ele.title, height: '7px', borderRadius: '4px' }} />
      );
    })}
  </Grid2>
  <Grid2 width="500px" className={styles1.sectorGrid} columnGap={2}>
    {[{ title: 'Mid Cap', color: '#934FB5' , percentage : "50%" }, { title: 'Small Cap', color: '#496E95', percentage : "50%" }].map((ele, index) => {
      return (
        <Box key={index}>
          <Grid2 display="flex" justifyContent="center" alignItems="center">
            <Grid2 sx={{ height: '10px', width: '10px', background: ele.color, borderRadius: '50%' }} />
            <Typography className={styles1.capText}>{ele?.title} - <span style={{fontWeight : "bold"}}>{ele?.percentage}</span></Typography>
          </Grid2>

        </Box>
      );
    })}
  </Grid2>
  
</Grid2>
                                    <Grid2 sx={{ display: "flex", justifyContent: "center", alignContent: "center",mt : "10px","@media (max-height: 630px)": {
  mt : "5px"
} }}>
                                        <Button onClick={()=>{
                                            setShowDetails(true)
                                            setDetails(energetic)
                                            }} disabled={loader} className={styles.knowMoreButton} >Know More <ArrowForwardIosIcon sx={{ fontSize: "14px" }} /> </Button>
                                    </Grid2>



            
                            </Grid2>
                        </Grid2>


                    </Grid2>
                </Grow>
            </> 
            

            <Modal
                open={paymentFailure}
                disableBackdropClick={false}
                onClose={handleClose}
                sx={{ border: 'none', zIndex: 1300 }}>
                <Box
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '50%',
                        height: 'auto',

                        outline: 'none',
                        background: '#ffffff',
                        p: 4,
                        borderRadius: '8px',
                        padding: '2%',
                        justifyContent: 'center', alignItems: 'center',
                        "@media only screen and (max-device-width: 480px)": {
                            width: '90%',


                        }
                    }}
                >
                    <Grid2 sx={{ display: "flex", justifyContent: "end" }}>
                        <IconButton onClick={() => setPaymentFailure(false)}>
                            <CloseIcon sx={{ color: "black" }} />
                        </IconButton>
                    </Grid2>
                    <Grid2 sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <img src={errorIcon} alt="errorIcon" width='70'></img>
                    </Grid2>
                    <Grid2 sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: "column", gap: "10px", marginTop: "10px", padding: "0px 20px" }}>
                        <Typography className={styles.payment_succ} >Payment Failed</Typography>
                        {paymentErrorMessage && <Typography className={styles.payment_msg}>Message: {paymentErrorMessage}</Typography>}
                        {paymentOrderId && <Typography className={styles.payment_msg}>Order No: {paymentOrderId}</Typography>}
                        {paymentTxId && <Typography className={styles.payment_msg1}>Transaction No: {paymentTxId}</Typography>}
                    </Grid2>
                </Box>
            </Modal>

            <Modal
                open={paymentSuccess}
                disableBackdropClick={false}
                onClose={() => setPaymentSuccess(false)}
                sx={{ border: 'none' }}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '50%',
                        height: 'auto',
                        outline: 'none',
                        background: '#ffffff',
                        p: 4,
                        borderRadius: '8px',
                        padding: '2%',
                        justifyContent: 'center', alignItems: 'center',
                        "@media only screen and (max-width: 1370px)": {
                            width: '70% !important',
                        },
                        "@media only screen and (max-width: 1000px)": {
                            width: '500px !important',
                            paddingY : "20px"
                        }, 
                        "@media only screen and (max-device-width: 650px)": {
                            width: '325px !important',
                        }
                    }}
                >
                    {/* Close Button */}
    <IconButton
      onClick={() => setPaymentSuccess(false)}
      sx={{ position: 'absolute', top: 8, right: 8 }}
    >
      <CloseIcon />
    </IconButton>
                    <Grid2 sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <img src={successIcon} alt={successIcon}  width= {screen1000px ? "55px" :'80px'}></img>
                    </Grid2>
                    <Grid2 sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: "column", gap: "10px", marginTop: "10px", padding: "0px 20px" }}>
                        <Typography className={styles.payment_succ} sx={{
                                fontFamily : "Inter600",
                                "@media only screen and (max-width: 1000px)": {
                            fontSize: '20px !important',
                        }
                            }}>Payment Successful</Typography>
                        {localStorage.getItem("paymentType")  == "subscription" && <>
                        <Typography className={styles.payment_msg}>Order No: {paymentOrderId}</Typography>
                        <Typography className={styles.payment_msg}>Transaction No: {paymentTxId}</Typography>
                        </>}
                        {localStorage.getItem("paymentType")  == "portfolio" && <>
                            <Typography className={styles.payment_msg} >Thank you! Your payment has been received.</Typography><Typography sx={{
                                fontFamily : "Inter600",
                                "@media only screen and (max-device-width: 1000px)": {
                            fontSize: '14px !important',
                        }
                            }} className={styles.payment_msg}>A Wealth Vault representative will reach out to you shortly from +91 8655627794.
                        Please save this number, or feel free to call us back on it if needed.</Typography></>}
                        <Grid2 style={{ width: '100%', borderBottom: '1px solid #D9D9D9' }}></Grid2>
                       <Typography className={styles.payment_msg} >Thank you! Your payment has been received.</Typography>
                        <Typography className={styles.payment_msg}>Amount: ₹{paymentAmount}</Typography>
                        {localStorage.getItem("paymentType")  == "portfolio" &&<Typography className={styles.payment_msg}>Transaction No: {paymentTxId}</Typography>}
                    </Grid2>
                </Box>
            </Modal>

            <Modal open={showDetails} onClose={()=>setShowDetails(false)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 600 },
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={()=>setShowDetails(false)}
          sx={{ position: 'absolute', top: 16, right: 16, color: 'grey.500' }}
        > 
          <CloseIcon />
        </IconButton>

        {/* Header */}
        <Typography variant="h4" fontWeight="bold" mb={1}>
          {details?.title}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" >
          Launch Date : <span style={{color : "black"}}>{details?.["Launch Date"]}</span> 
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" mb={3}>
          Benchmark - <span style={{color : "black"}}>{details?.Benchmark}</span> , Asset Class - <span style={{color : "black"}}>{details?.["Asset Class"]}</span>
        </Typography>
        

        {/* Body */}
        <Typography variant="h6" fontWeight="bold" mb={"5px"}>
          Model Portfolio Rationale
        </Typography>

        <Typography variant="body1" mb={2}>
        {details?.Rationale?.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br /> 
    </React.Fragment>
  ))}
        </Typography>

        <Typography variant="h6" fontWeight="bold" mb={2}>
          Key Features of the Balanced Portfolio:
        </Typography>

        {details?.["key features"]?.map(ele =>{
            return(

        <Typography variant="body1" mb={1}>
          <strong>{ele?.split(":")[0]} :</strong> {ele?.split(":")[1]}
        </Typography>
            )
        })}

<Typography sx={{fontSize : "14px", mt : "20px"}} fontWeight="bold">
          Disclaimer
        </Typography>
        <Typography sx={{fontSize : "12px"}} mb={1}>
            {details?.disclaimer}
        </Typography>
      </Box>
    </Modal>
        </Grid2>
    )
}
  